/* Englputzeder – Produktseiten-Bausteine (ep-pdp-*): Sprungnavigation, Hotspots, Videos, Lightbox */
(function () {
  if (window.EP_PDP_LOADED) return;
  window.EP_PDP_LOADED = true;

  function headerOffset() {
    var off = 0;
    document.querySelectorAll('.shopify-section-group-header-group, sticky-header, .header--sticky').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.top <= 1 && r.bottom > 0) off = Math.max(off, r.bottom);
    });
    return off;
  }

  function findSection(key) {
    if (!key) return null;
    return document.querySelector('[id$="__' + key + '"].shopify-section') || document.getElementById(key);
  }

  /* ---------- Sprungnavigation ---------- */
  function initNav(nav) {
    if (nav.dataset.epInit) return;
    nav.dataset.epInit = '1';
    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-ep-target]'));
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = findSection(a.getAttribute('data-ep-target'));
        if (!t) return;
        e.preventDefault();
        var y = t.getBoundingClientRect().top + window.pageYOffset - headerOffset() - nav.offsetHeight - 8;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      });
    });
    var ticking = false;
    function update() {
      ticking = false;
      var top = headerOffset();
      var wrap = nav.closest('.shopify-section') || nav; wrap.style.top = top + 'px';
      var line = top + nav.offsetHeight + 40, active = null, any = false;
      links.forEach(function (a) {
        var t = findSection(a.getAttribute('data-ep-target'));
        var ok = !!(t && t.offsetHeight > 20);
        a.closest('li').hidden = !ok;
        a._t = ok ? t : null;
        if (ok) { any = true; if (t.getBoundingClientRect().top <= line) active = a; }
      });
      links.forEach(function (a) { a.classList.toggle('is-active', a === active); });
      var sec = nav.closest('.shopify-section'); if (sec) sec.hidden = !any;
      var list = nav.querySelector('ul');
      if (active && list.scrollWidth > list.clientWidth) {
        var l = active.offsetLeft;
        if (l < list.scrollLeft || l + active.offsetWidth > list.scrollLeft + list.clientWidth) list.scrollLeft = l - 16;
      }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    setTimeout(update, 1500);
    update();
  }

  /* ---------- Hotspots ---------- */
  function closeAll(except) {
    document.querySelectorAll('.ep-pdp-hs__spot.is-open').forEach(function (s) {
      if (s === except) return;
      s.classList.remove('is-open');
      var b = s.querySelector('.ep-pdp-hs__dot');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function initHotspots(root) {
    if (root.dataset.epInit) return;
    root.dataset.epInit = '1';
    root.querySelectorAll('.ep-pdp-hs__spot').forEach(function (s) {
      var b = s.querySelector('.ep-pdp-hs__dot');
      var x = parseFloat(s.style.left), y = parseFloat(s.style.top);
      if (x > 62) s.classList.add('ep-pdp-hs__spot--left');
      else if (x < 38) s.classList.add('ep-pdp-hs__spot--right');
      if (y > 55) s.classList.add('ep-pdp-hs__spot--up');
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !s.classList.contains('is-open');
        closeAll(s);
        s.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  document.addEventListener('click', function (e) { if (!e.target.closest('.ep-pdp-hs__card')) closeAll(null); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(null); closeLb(); } });

  /* ---------- Videos ---------- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setPlaying(card, on) { card.classList.toggle('is-playing', on); var b = card.querySelector('.ep-pdp-vid__toggle'); if (b) b.setAttribute('aria-label', on ? 'Video pausieren' : 'Video abspielen'); }
  function load(v) { if (!v.getAttribute('src') && v.dataset.src) { v.src = v.dataset.src; } }
  function play(card) { var v = card.querySelector('video'); if (!v) return; load(v); var p = v.play(); setPlaying(card, true); if (p && p.catch) p.catch(function () { setPlaying(card, false); }); }
  function pause(card) { var v = card.querySelector('video'); if (!v) return; v.pause(); setPlaying(card, false); }
  function initVideos(root) {
    if (root.dataset.epInit) return;
    root.dataset.epInit = '1';
    var cards = root.querySelectorAll('.ep-pdp-vid__card');
    cards.forEach(function (c) {
      var b = c.querySelector('.ep-pdp-vid__toggle');
      c.dataset.manual = '';
      if (b) b.addEventListener('click', function () { c.dataset.manual = '1'; if (c.classList.contains('is-playing')) pause(c); else play(c); });
      c.querySelector('video').addEventListener('click', function () { if (b) b.click(); });
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var c = en.target;
        if (en.isIntersecting && en.intersectionRatio >= 0.6) { if (!reduce && !c.dataset.manual && root.dataset.autoplay === 'true') play(c); else load(c.querySelector('video')); }
        else if (c.classList.contains('is-playing')) pause(c);
      });
    }, { threshold: [0, 0.6] });
    cards.forEach(function (c) { io.observe(c); });
  }

  /* ---------- Lightbox Inspiration ---------- */
  var lb;
  function closeLb() { if (lb && !lb.hidden) { lb.hidden = true; document.documentElement.style.overflow = ''; } }
  function openLb(src, alt) {
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'ep-pdp-lb ep-pdp';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.innerHTML = '<img alt=""><button type="button" aria-label="Schließen">&times;</button>';
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.tagName === 'BUTTON') closeLb(); });
      document.body.appendChild(lb);
    }
    var img = lb.querySelector('img'); img.src = src; img.alt = alt || '';
    lb.hidden = false; document.documentElement.style.overflow = 'hidden';
    lb.querySelector('button').focus();
  }
  function initInsp(root) {
    if (root.dataset.epInit) return;
    root.dataset.epInit = '1';
    root.querySelectorAll('[data-ep-zoom]').forEach(function (b) {
      b.addEventListener('click', function () { var i = b.querySelector('img'); openLb(b.getAttribute('data-ep-zoom'), i ? i.alt : ''); });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-ep-pdp-nav]').forEach(initNav);
    scope.querySelectorAll('[data-ep-pdp-hotspots]').forEach(initHotspots);
    scope.querySelectorAll('[data-ep-pdp-videos]').forEach(initVideos);
    scope.querySelectorAll('[data-ep-pdp-insp]').forEach(initInsp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
